module.exports = __webpack_public_path__ + "img/Steor-Icons-14.ec26a3b8.svg";